import { render, staticRenderFns } from "./LoginStudent.vue?vue&type=template&id=8728f25a&"
import script from "./LoginStudent.vue?vue&type=script&lang=js&"
export * from "./LoginStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports